"use client"
import StickyHeader from "./StickyHeader"
import ProcesoContacto from "./ProcesoContacto"
import "../css/erp.css"
import imgMainImg from "../img/erp/imagebnnr.png"
import imgGif from "../img/erp/imggif.png"
import imgGif2 from "../img/erp/imggif2.png"
import imgGif3 from "../img/erp/imggif3.png"
import imgGif4 from "../img/erp/imggif4.png"

const Erp = () => {
  return (
    <>
      <section className="erp-hero">
        <StickyHeader />
        <div className="erp-container">
          <div className="erp-hero-content mobile-order">
            <div className="erp-hero-text">
              <div className="divtxts">
                <h1>
                  <strong style={{ color: "#E30615" }}>Sistema Empresarial</strong> ERP 100% flexible
                </h1>
                <p>
                  En un entorno empresarial que cambia rápidamente, contar con una plataforma empresarial modular es
                  clave para optimizar tus procesos, mejorar la productividad y tomar decisiones basadas en datos
                  precisos.
                </p>
                {/* Cambiado de button a anchor con href */}
                <a href="/contacto" className="erp-button" style={{ color: "white" }}>
                  Comunícate con nosotros
                </a>
              </div>
            </div>

            <div className="image-container">
              <div className="erp-hero-image">
                <img src={imgMainImg || "/placeholder.svg"} alt="Dashboard de gestión" width="700px" height="700px" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="erp-integration">
        <div className="erp-container">
          <div className="erp-integration-content mobile-order">
            <div className="integration-image-container">
              <img src={imgGif || "/placeholder.svg"} alt="Integración de herramientas" className="integration-image" />
            </div>

            <div className="integration-text">
              <h2>Cada empresa tiene necesidades únicas.</h2>
              <p>
                Nuestro ERP ofrece una estructura modular que te permite elegir solo las funcionalidades que realmente
                necesitas, y crecer con tu negocio agregando nuevos módulos a medida que lo requieras. Esto asegura que
                tu inversión siempre se ajuste a las necesidades de tu empresa.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <p> </p>
      </section>
      <ProcesoContacto />

      {/* Sección CTA con fondo rojo */}
      <section className="erp-cta">
        <div className="erp-container">
          <div className="erp-cta-content">
            <h2>Libera todo el potencial de tu empresa con nuestro ERP</h2>
            <a href="/contacto" className="erp-button-bordered">
              Comunícate con nosotros
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="arrow-icon"
              >
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </a>
          </div>
        </div>
      </section>

      {/* Nueva sección 1: Imagen a la derecha */}
      <section className="erp-feature">
        <div className="erp-container">
          <div className="erp-feature-content mobile-order">
            <div className="feature-text">
              <div className="feature-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#00B67A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <line x1="6" y1="8" x2="18" y2="8" />
                  <line x1="6" y1="12" x2="18" y2="12" />
                  <line x1="6" y1="16" x2="18" y2="16" />
                </svg>
              </div>
              <h2>A medida que tu negocio evoluciona, también lo hacen sus requerimientos.</h2>
              <p>
                Nuestro sistema está diseñado para adaptarse a cualquier cambio, permitiendo personalizaciones
                ilimitadas para ajustarse a tus procesos específicos sin complicaciones. Puedes modificar desde las
                funcionalidades hasta el diseño, sin limitaciones.
              </p>
            </div>
            <div className="feature-image">
              <div className="feature-image-container">
                <img src={imgGif2 || "/placeholder.svg"} alt="Automatización de procesos" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Nueva sección 2: Imagen a la izquierda */}
      <section className="erp-feature">
        <div className="erp-container">
          <div className="erp-feature-content-left mobile-order">
            <div className="feature-image">
              <div className="feature-image-container">
                <img src={imgGif3 || "/placeholder.svg"} alt="Análisis de datos" />
              </div>
            </div>
            <div className="feature-text">
              <div className="feature-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#4A6CF7"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 20V10" />
                  <path d="M18 20V4" />
                  <path d="M6 20v-4" />
                </svg>
              </div>
              <h2>Accede a información crítica del negocio cuando la necesites.</h2>
              <p>
                Nuestros paneles personalizables y reportes en tiempo real te permiten visualizar tendencias,
                identificar oportunidades y resolver fallas antes de que afecten tu operación.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Nueva sección 3: Imagen a la derecha */}
      <section className="erp-feature">
        <div className="erp-container">
          <div className="erp-feature-content mobile-order">
            <div className="feature-text">
              <div className="feature-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#FF6B6B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <h2>
                Conecta a todos tus colaboradores en una plataforma unificada, <br></br>sin importar dónde se
                encuentren.
              </h2>
              <p>
                Facilita la comunicación, el seguimiento de proyectos y el intercambio de información crítica para
                mantener a todos alineados con los objetivos de la empresa.
              </p>
            </div>
            <div className="feature-image">
              <div className="feature-image-container">
                <img src={imgGif4 || "/placeholder.svg"} alt="Colaboración de equipos" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Erp
